import { Icon } from '@pms-digital/design-system';

/** What an open folder without any matrix shows after the « + » card (issue #19, planche 16). */
export function FolderEmptyState() {
  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border-2 border-gray-200 border-dashed px-6 py-8 text-center">
      <Icon name="folder" />
      <h3 className="mt-1 font-semibold text-small">Ce dossier est vide</h3>
      <p className="text-gray-600 text-small">
        Glissez une matrice sur le dossier, ou utilisez « Déplacer vers ».
      </p>
    </div>
  );
}
